import { useContext } from "react";
import { AnalyticsContext } from "../AnalyticsProvider";
var useWidgetAnalytics = function () {
    var analytics = useContext(AnalyticsContext);
    return analytics;
};
export default useWidgetAnalytics;
